import { Injectable } from "@angular/core";

@Injectable()
export abstract class LocalStorageRepositoryInterface {

    public abstract getToken(): string;

    public abstract setToken(value: string);

    public abstract removeToken();

    public abstract getRefreshToken(): string;

    public abstract setRefreshToken(value: string);

    public abstract removeRefreshToken();

    public abstract getLoggedEmail(): string;

    public abstract setLoggedEmail(value: string);

    public abstract removeLoggedEmail();

    public abstract getLoggedUserId(): string;

    public abstract setLoggedUserId(value: string);

    public abstract removeLoggedUserId();

    public abstract getInfoPlantToken();

    public abstract setInfoPlantToken(value: string);

    public abstract removeInfoPlantToken();

    public abstract getCurrentLanguage();

    public abstract setCurrentLanguage(value: string);

    public abstract removeCurrentLanguage();
}
